/**
 * Internal dependencies
 */
export { init, metadata, name, settings } from './index';
